(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/setup-subscription.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/setup-subscription.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  createWagerObject,
  fetchDrawData,
  PRICE_PER_WEEK
} = svs.tur.pay_lyckoplatsen;
const {
  logger
} = svs.tur.pay_lyckoplatsen;
const browserStorage = svs.components.Storage.browser;
const currencyAsJupiterString = svs.utils.format.CurrencyAsJupiterString;
const STATUS_ACTIVE = 1;
function charityNotActiveDialog() {
  return new Promise(resolve => {
    svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      icon: 'information',
      area: svs.ui.dialog.area.POPUP,
      type: svs.ui.dialog.type.CONFIRM,
      title: 'Organisationen är inte längre tillgänglig',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: "Organisationen \xE4r tyv\xE4rr inte l\xE4ngre tillg\xE4nglig. Du kan v\xE4lja en ny organisation att st\xF6tta n\xE4r prenumerationen \xE4r lagd.",
        align: svs.components.dialog.message.align.CENTER
      }],
      actions: [{
        title: 'Fortsätt',
        callback: (_e, _forms, dialog) => {
          dialog.close();
          resolve();
        }
      }]
    }));
  });
}
async function setupSubscription(_ref) {
  let {
    data,
    callback,
    subscriptionId
  } = _ref;
  const storageKey = subscriptionId ? 'change' : 'start';
  logger.info("Setup ".concat(storageKey, " lyckoplatsen subscription"));
  const formattedPrice = currencyAsJupiterString(PRICE_PER_WEEK);
  const drawData = await fetchDrawData(data.numberOfWeeks);
  const primaryDraw = drawData.primaryDraw;
  data.primaryDraw = primaryDraw;
  data.secondaryDraw = drawData.secondaryDraw;
  const charityId = data.charityId;
  let charity = data.charity;
  if (charityId) {
    if (!charity) {
      logger.info("Fetching charity data for charityId: ".concat(charityId));
      const {
        response
      } = await svs.core.jupiter.callAsync({
        path: "/charity/1/externalcharities/".concat(charityId),
        method: 'GET'
      });
      charity = response.charity;
    }
    const charityStatus = charity.status;
    if (charityId && charityStatus !== STATUS_ACTIVE) {
      logger.info("Removing inactive charity. Id: ".concat(charityId, ", status: ").concat(charityStatus));
      delete data.charity;
      delete data.charityId;
      await charityNotActiveDialog();
    }
  }
  const apiWager = createWagerObject(data);
  apiWager.wagerAmount = formattedPrice;
  apiWager.bets[0] = _objectSpread(_objectSpread({}, apiWager.bets[0]), {}, {
    betAmountSalesGroup1: formattedPrice,
    betProperties: ['SUBSCRIPTION'],
    numDraws: 1
  });
  apiWager.bets[1] = _objectSpread(_objectSpread({}, apiWager.bets[1]), {}, {
    betProperties: ['SUBSCRIPTION'],
    numDraws: 1
  });
  browserStorage.set(storageKey, 'subscription', {
    options: {
      product: 'Lyckoplatsen',
      subscriptionPackageId: 'lyckoplatsen',
      weeklyCost: formattedPrice,
      gameDays: '',
      numberOfBoards: 1
    },
    entry: {
      packageIdWager0: 0,
      packageIdWager1: 0,
      wagers: [apiWager],
      subscriptionIdRef: subscriptionId,
      rowpriceMain: formattedPrice,
      rowpriceAddon: currencyAsJupiterString(0)
    }
  }, 15, callback);
}
setGlobal('svs.tur.pay_lyckoplatsen.setupSubscription', setupSubscription);

 })(window);